"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dropdownMenuModule = _interopRequireDefault(require("./dropdownMenu.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownMenu = function DropdownMenu(props) {
  var id = props.id,
      options = props.options;
  return _react.default.createElement("ul", {
    id: id ? "".concat(id, "_list") : null,
    className: _dropdownMenuModule.default['dropdown-menu']
  }, options.map(function (option) {
    return _react.default.createElement(_react.default.Fragment, {
      key: option.key
    }, option.divided && _react.default.createElement("li", {
      id: id ? "".concat(id, "_item_").concat(option.key, "_divider") : null,
      className: _dropdownMenuModule.default['divider']
    }), _react.default.createElement("li", {
      id: id ? "".concat(id, "_item_").concat(option.key) : null
    }, _react.default.createElement("a", {
      id: id ? "".concat(id, "_item_").concat(option.key, "_label") : null,
      onClick: option.onClick
    }, option.label)));
  }));
};

DropdownMenu.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** the menu options array of objects. Each one must have an onClick callback, a label, a key, and a flag indicated
   * it is divided */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    onClick: _propTypes.default.func,
    divided: _propTypes.default.bool,
    label: _propTypes.default.string,
    key: _propTypes.default.string
  })).isRequired
};
var _default = DropdownMenu;
exports.default = _default;